#import "./AddressFull.graphql"
#import "./SearchIndexFull.graphql"
#import "./TimestampsFull.graphql"
#import "./CompanyFull.graphql"

fragment CustomerFull on Customer {
  id
  allowPaymentOnInvoice
  billingAddress {
    ...AddressFull
  }
  blockedAt
  blockedBy
  cognitoId
  cognitoProvider
  company {
    ...CompanyFull
  }
  deliveryAddresses {
    ...AddressFull
  }
  email
  isCustomerB2f
  fakturoidOssSubjectId
  fakturoidSubjectId
  fullName
  gdprApprovedAt
  invoiceEmail
  maximumOverdueInvoiceAmount
  locale
  phoneNumber
  pricingLevel
  subscribeToNewsletter
  validVat
  ...TimestampsFull
  ...SearchIndexFull
}
